export function normalizeDocument (value) {
  if (value == null || value === '') return ''
  return String(value).replace(/[^0-9A-Za-z]/g, '').toUpperCase()
}

export function detectDocumentType (value) {
  const document = normalizeDocument(value)
  if (document.length === 11 && /^\d{11}$/.test(document)) return 'CPF'
  if (document.length === 14 && /^[A-Z0-9]{12}\d{2}$/.test(document)) return 'CNPJ'
  return null
}

function hasRepeatedCharacters (document) {
  return /^(.)\1+$/.test(document)
}

function computeCheckDigit (values, weights) {
  const sum = weights.reduce((total, weight, index) => total + values[index] * weight, 0)
  const remainder = sum % 11
  return remainder < 2 ? 0 : 11 - remainder
}

function isValidCpf (document) {
  if (hasRepeatedCharacters(document)) return false
  const digits = document.split('').map(Number)
  const firstDigit = computeCheckDigit(digits.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2])
  const secondDigit = computeCheckDigit(digits.slice(0, 10), [11, 10, 9, 8, 7, 6, 5, 4, 3, 2])
  return firstDigit === digits[9] && secondDigit === digits[10]
}

function isValidCnpj (document) {
  if (hasRepeatedCharacters(document)) return false
  const values = document.split('').map(character => character.charCodeAt(0) - 48)
  const checkDigits = document.slice(12).split('').map(Number)
  const firstDigit = computeCheckDigit(values.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  const secondDigit = computeCheckDigit(values.slice(0, 13), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  return firstDigit === checkDigits[0] && secondDigit === checkDigits[1]
}

export function isValidDocument (value) {
  const type = detectDocumentType(value)
  const document = normalizeDocument(value)
  if (type === 'CPF') return isValidCpf(document)
  if (type === 'CNPJ') return isValidCnpj(document)
  return false
}

export function maskDocument (value) {
  const document = normalizeDocument(value)
  if (document === '') return ''
  const type = detectDocumentType(document)
  if (type === 'CPF') return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  if (type === 'CNPJ') return document.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5')
  return document
}



// WEBPACK FOOTER //
// ./src/utils/document.js